class SessionCache {

    constructor() {

        this.objectPrefix = 'object!';
    
    }

    set(key, value) {

        if(typeof value !== 'string') {

            value = this.objectPrefix + JSON.stringify(value);

        }
        sessionStorage.setItem(key, value);

    }

    get(key) {

        let value = sessionStorage.getItem(key) || "";
        if(value.indexOf(this.objectPrefix) === 0) {

            value = JSON.parse(value.substr(this.objectPrefix.length));

        }
        return value;

    }

    remove(key) {

        sessionStorage.removeItem(key);

    }

    clear() {

        sessionStorage.clear();

    }

}

export const sessionCache = new SessionCache();
